import { render, staticRenderFns } from "./ProductBody.vue?vue&type=template&id=481bdea0"
import script from "./ProductBody.vue?vue&type=script&lang=js"
export * from "./ProductBody.vue?vue&type=script&lang=js"
import style0 from "./ProductBody.vue?vue&type=style&index=0&id=481bdea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports